import React from 'react';
import moment from 'moment';

import { ButtonLink } from '../../../components/general';

import { URL } from '../../../constants';

import { ExtendedEvent, getAssetsFile } from './getData';

interface Props {
  event: ExtendedEvent;
}

const EventBlock: React.FC<Props> = (props) => {
  const { event } = props;

  return (
    <ButtonLink
      to={`${URL.ATTENDEE_PORTAL}/${event.eventId}`}
      variant="custom"
      colour="custom"
      className="w-[var(--project-block-width)]"
    >
      <img
        className="w-full aspect-video mb-1 sm:mb-2 rounded-md object-cover"
        src={getAssetsFile('banner.png', event.eventId)}
        alt={`${event.name} Thumbnail`}
      />

      <div className="text-xs sm:text-sm font-bold text-black hover:text-primary-900">
        {event.name}
      </div>

      <div className="flex justify-between flex-wrap gap-x-2 text-xs text-black opacity-50">
        <div className="capitalize">{event.videoMode}</div>
        <div>{moment(event.modified).fromNow()}</div>
      </div>
    </ButtonLink>
  );
};

export default EventBlock;
